var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-sample" }, [
    _vm.isThemeSfr
      ? _c("div", { staticClass: "notification-header" }, [
          _c("div", {
            staticClass: "icon",
            style: { backgroundImage: "url(" + _vm.sfrLogo + ")" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "app-label" }, [_vm._v("SFR DATI")]),
        ])
      : _vm.isThemeCatsafe
      ? _c("div", { staticClass: "notification-header" }, [
          _c("div", {
            staticClass: "icon",
            style: { backgroundImage: "url(" + _vm.catsafeLogo + ")" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "app-label" }, [_vm._v("CAT'SAFE")]),
        ])
      : _c("div", { staticClass: "notification-header" }, [
          _c("div", {
            staticClass: "icon",
            style: { backgroundImage: "url(" + _vm.appLogo + ")" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "app-label" }, [_vm._v("Beepiz")]),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "notification-content" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
        _c(
          "span",
          { staticClass: "placeholder", class: { show: _vm.title == "" } },
          [_vm._v(" ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description pre-style" }, [
        _vm._v(_vm._s(_vm.description)),
        _c(
          "span",
          {
            staticClass: "placeholder",
            class: { show: _vm.description == "" },
          },
          [_vm._v(" ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }